import { render, staticRenderFns } from "./WolfStatus.vue?vue&type=template&id=a1607384&scoped=true&"
import script from "./WolfStatus.vue?vue&type=script&lang=js&"
export * from "./WolfStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1607384",
  null
  
)

export default component.exports